/** User-facing copy for the Fund Accounts screen, following the `texts.ts` convention its sibling
 *  engines use (`SystemConfiguration/DelegatedAuthority/texts.ts` and nine others). Collected here
 *  so the wording can be changed — or one day translated — without reading the components.
 *
 *  Currently covers the default-behaviour card and its dialog. The rules table, filters and rule
 *  dialog still hold their copy inline; they migrate into this same object rather than a second
 *  file. */
export const TEXTS = {
  DEFAULT_BEHAVIOR_TITLE: 'Default Behavior',
  DEFAULT_BEHAVIOR_SUBTITLE: 'What the engine does with a payment that matches none of the rules below.',

  BEHAVIOR_SUMMARY_LABEL: 'Behavior',
  ACCOUNT_SUMMARY_LABEL: 'Default Account Number',

  BEHAVIOR_FIELD_LABEL: 'Default Behavior',
  ACCOUNT_FIELD_LABEL: 'Default Account Number',

  EDIT_DIALOG_TITLE: 'Edit default behavior',
  EDIT_TOOLTIP: 'Edit default behavior',
  SET_UP_TOOLTIP: 'Set up default behavior',

  BEHAVIOR_DEFAULT_ACCOUNT: 'Use a default account',
  BEHAVIOR_BLOCK_PAYMENT: 'Block payment',
  BEHAVIOR_SEND_EMPTY: 'Ignore & send empty',

  BEHAVIOR_REQUIRED: 'Default behavior is required',
  ACCOUNT_REQUIRED: 'Default account number is required',

  ALERT_TITLE: 'Please Note',

  /** The engine resolves `send_empty` to no account whatever the provider; whether an empty account
   *  is acceptable is the provider's question, asked at the approval seam against its own
   *  `is_fund_account_required` flag. So the copy states the requirement rather than naming the one
   *  provider that carries it today — a provider gaining or losing it is a line of enum data. */
  SEND_EMPTY_WARNING:
    'Payments routed to a payment provider that requires a fund account will fail at approval when ' +
    'they match no rule. Only payment methods whose provider does not require one — or that have no ' +
    'payment-provider integration at all — can be sent without a fund account.',

  /** An engine with no behaviour chosen blocks `source='rules'` on every payment-method config, so
   *  the summary states the consequence rather than rendering a blank value. */
  NOT_CONFIGURED_WARNING: "Not configured. Payment methods can't use rules until a default behavior is set.",
};
